import {Button, COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import React, {ComponentProps} from 'react';
import styled from 'styled-components';

export const ArrowButton: React.FC<
  React.PropsWithChildren<ComponentProps<typeof Button>>
> = ({children}) => {
  return (
    <StyledButton variant="secondary" aria-label={undefined}>
      {children}
      <Icon fill={COLORS.Grey2} size="XS" asset={GenericIconName.ArrowRight} />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  && {
    padding: 20px;
    text-align: left;
  }
`;
